export const SET_MODAL_LOGIN_USERS = 'SET_MODAL_LOGIN_USERS'
export const SET_MODAL_LOGIN_ACCESS_TOKEN = 'SET_MODAL_LOGIN_ACCESS_TOKEN'
export const SET_MODAL_LOGIN_REFRESH_TOKEN = 'SET_MODAL_LOGIN_REFRESH_TOKEN'
export const SET_MODAL_LOGIN_INVALID_PASSWORD_ERROR = 'SET_MODAL_LOGIN_INVALID_PASSWORD_ERROR'
export const SET_MODAL_LOGIN_LOADING = 'SET_MODAL_LOGIN_LOADING'
export const SET_MODAL_LOGIN_OPEN_FOR_WAITER = 'SET_MODAL_LOGIN_OPEN_FOR_WAITER'
export const SET_PIN_CODE_MODAL_LOGIN_IS_NEEDED = 'SET_PIN_CODE_MODAL_LOGIN_IS_NEEDED'
export const SET_MODAL_LOGIN_USERNAME = 'SET_MODAL_LOGIN_USERNAME'
